import { Component, Input, Output, OnInit, forwardRef, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-datepicker-range',
  templateUrl: './form-datepicker-range.component.html',
  styleUrls: ['./form-datepicker-range.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDatepickerRangeComponent),
      multi: true
    }
  ]
})
export class FormDatepickerRangeComponent implements OnInit, ControlValueAccessor {
  @Input()  resetable = true;
  @Input()  required = false;
  @Input()  disabled = false;
  @Input()  name = 'date';
  @Input()  min = null;
  @Input()  max = null;
  @Input()  placeholderStart = '…';
  @Input()  placeholderEnd = '…';
  @Output() dateChange: EventEmitter<any>;
  @ViewChild('dateElementStart') dateElementStart: ElementRef;
  @ViewChild('dateElementEnd') dateElementEnd: ElementRef;

  public date: any = { start: null, end: null };

  public rangeDateClass: (d: Date) => any;

  propagateChange = (_: any) => {};

  constructor() {
    this.dateChange = new EventEmitter();
  }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.date = value || { start: null, end: null };
    this.setRangeClass();
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  onDateChangeStart(date) {
    date = new Date(date);
    if (date) {
      date.setUTCHours(0, 0, 0, 0);
    }

    this.date.start = date;
    this.propagateChange(this.date);
    this.setRangeClass();
    this.dateChange.emit(this.date);
  }

  onDateChangeEnd(date) {
    date = new Date(date);
    if (date) {
      date.setUTCHours(23, 59, 59, 999);
    }

    this.date.end = date;
    this.propagateChange(this.date);
    this.setRangeClass();
    this.dateChange.emit(this.date);
  }

  onClearClick(which) {
    if (which === 'START') {
      this.dateElementStart.nativeElement.focus();
      this.date.start = null;
      this.dateElementStart.nativeElement.blur();
    }

    if (which === 'END') {
      this.dateElementEnd.nativeElement.focus();
      this.date.end = null;
      this.dateElementEnd.nativeElement.blur();
    }

    this.propagateChange(this.date);
    this.dateChange.emit(this.date);
    this.setRangeClass();
  }

  getMinStart() {
    return this.min;
  }

  getMaxStart() {
    return this.date.end || this.max;
  }

  getMinEnd() {
    return this.date.start || this.min;
  }

  getMaxEnd() {
    return this.max;
  }

  private setRangeClass() {
    function getTimestamp(date) {
      date = new Date(date);
      date.setUTCHours(0, 0, 0, 0);
      return date.getTime();
    }

    this.rangeDateClass = (d: Date) => {
      const inRangeStart = this.date.start && getTimestamp(d) >= getTimestamp(this.date.start);
      const inRangeEnd = this.date.end && getTimestamp(d) <= getTimestamp(this.date.end);

      if (getTimestamp(d) === getTimestamp(this.date.start) || getTimestamp(d) === getTimestamp(this.date.end)) {
        return 'widget-datepicker-range-is';
      }

      if (inRangeStart && !this.date.end) {
        return 'widget-datepicker-range-in';
      }

      if (inRangeEnd && !this.date.start) {
        return 'widget-datepicker-range-in';
      }

      if (inRangeStart && inRangeEnd) {
        return 'widget-datepicker-range-in';
      }
    };
  }
}
